import { render, staticRenderFns } from "./onBoard.vue?vue&type=template&id=af3318c6&"
import script from "./onBoard.vue?vue&type=script&lang=js&"
export * from "./onBoard.vue?vue&type=script&lang=js&"
import style0 from "./onBoard.vue?vue&type=style&index=0&id=af3318c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports